export default __webpack_public_path__ + "6946c520804b31aa7e5990ec8026f4cc.png";